export const MESSAGE_LIST_MAX_CARD_NUMBER_NEW = 'activity_item_list__max_card_number__limit_new_value';
export const MESSAGE_LIST_MAX_CARD_NUMBER_OLD = 'activity_item_list__max_card_number__limit_old_value';
